// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import HourglassOutlinedSvg from "@ant-design/icons-svg/es/asn/HourglassOutlined";
import AntdIcon from '../components/AntdIcon';

var HourglassOutlined = function HourglassOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: HourglassOutlinedSvg
  }));
};

HourglassOutlined.displayName = 'HourglassOutlined';
export default /*#__PURE__*/React.forwardRef(HourglassOutlined);